import React, { useState } from "react";
import ScannerV2 from "./ScannerV2";

const ScannerComponent = () => {
  const [scannedData, setScannedData] = useState(null);

  const handleDetected = (data) => {
    console.log("Barcode detected:", data);
    setScannedData(data);
  };

  return (
    <div style={{ width: "100vw", height: "100vh" }}>
      <ScannerV2 onDetected={handleDetected} />
      {scannedData && (
        <div
          style={{ position: "absolute", bottom: "10%", textAlign: "center" }}
        >
          <h3>Scanned Data:</h3>
          <p>{scannedData}</p>
        </div>
      )}
    </div>
  );
};

export default ScannerComponent;
